// @flow
import styled from 'styled-components';

import {
  CLARK_SECONDARY,
  CLARK_TERTIARY,
  LINK_COLOR_PRIMARY,
  LINK_COLOR_SECONDARY,
} from 'styles/colors';
import { SPACING_EXTRA_SMALL, SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { TYPE_SCALE_F5, TYPE_SCALE_F6 } from 'styles/type-scale';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { BORDER_WIDTH_1 } from 'styles/borders';
import { EASE_IN_OUT_25 } from 'styles/transitions';

export const CreditCardLogo = styled.img`
  width: 25px;
`;

export const CreditCardLastFour = styled.span`
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  ${TYPE_SCALE_F6};
  color: ${CLARK_SECONDARY};
`;

export const PaymentMethodDetails = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 ${SPACING_MEDIUM};
`;

export const ReplaceCard = styled.div`
  ${FONT_WEIGHT_100};
  ${TYPE_SCALE_F6};
  ${LINE_HEIGHT_COPY};
  border-bottom: ${BORDER_WIDTH_1} dashed ${LINK_COLOR_PRIMARY};
  color: ${CLARK_TERTIARY};
  display: inline;
  margin-left: ${SPACING_EXTRA_SMALL};
  outline: 0;
  text-decoration: none;
  ${EASE_IN_OUT_25};

  &:hover {
    cursor: pointer;
    color: ${LINK_COLOR_SECONDARY};
    border-bottom: ${BORDER_WIDTH_1} dashed ${LINK_COLOR_SECONDARY};
  }
`;

export const SubmitInfoCopy = styled.h3`
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  ${TYPE_SCALE_F5};
  color: ${CLARK_SECONDARY};
  margin-bottom: ${SPACING_LARGE};
`;



// WEBPACK FOOTER //
// ./src/components/payer/credit-card-details-form/styles.js